import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const AlarmItemStyled = styled.div`
  align-items: center;
  background: white;
  border-bottom: 1px solid ${props => props.theme.grayUltraLight};
  color: ${props => props.theme.textColor};
  height: auto !important;
  display: flex;
  padding: 0.8rem 0;
  width: 100%;

  .alarmItem { 
    .itemHeader {
      color: ${props => props.theme.textColor};

      .itemHeaderColumn {
        white-space: nowrap;
        ${mixins.ellipsis};
      }
    }

    &__itemHeaderColumn {
      font-size: 0.825rem;
      line-height: 25px;
      padding: 0 0.625rem;
      float: left;

      &.toggle {
        width: 11%;
      }

      &.name {
        width: 22%;
      }

      &.description {
        width: 29.4%;
        line-height: 25px;
      }

      &.subscription,
      &.settings {
        width: 11%;
        text-align: center;

        i {
          line-height: 33px;
          cursor: pointer;
          font-size: 1.25rem;

          &.alarmSettingsToggle {
            &:hover {
              color: ${props => props.theme.brand};
            }
          }
        }

        &.subscription {
          width: 13.8%;
          float: right;

          .subscribed,
          .unsubscribed {
            line-height: 33px;

            &.subscribed {
              color: ${props => props.theme.brand};
            }

            &.unsubscribed {
              color: ${props => props.theme.textColor};
            }
          }
        }
      }

      &.toggle {
        .alarmToggle {
          padding: 0.35rem;
          margin-bottom: 0;
          width: 70px;
          border-radius: 5px;
          cursor: pointer;

          span {
            color: white;
            font-size: 0.75rem;

            .fa {
              margin-right: 0.5rem;
            }
          }

          &.enabledButton {
            background-color: ${props => props.theme.successLight};
          }

          &.disabledButton {
            background-color: ${props => props.theme.errorLight};
          }
        }
      }
    }

    &Tooltip {
      position: relative;
      width: 250px;
      left: -50px;

      &__closeTooltip {
        position: absolute;
        left: 0.75rem;
        color: ${props => props.theme.bgColor};
      }
    }
  }
`;
